// This file was auto-generated by Fern from our API Definition.
export const EvaluationStatus = {
    Pending: "pending",
    Queued: "queued",
    Running: "running",
    Success: "success",
    Failure: "failure",
    Errors: "errors",
    Cancelled: "cancelled",
};
